
export interface MyLoadsFilterProgram
{
    profileName?: string,
    year?: number,
    clientId?: number,
    programId?: number,
    transportType?: number,
    status?: number,
    importOrder?: string,
    speciesId?: string,
    varietyId?: string,
    naveId?: string,
    departurePortId?: string,
    destinationPortId?: string,
}

export interface MyLoadsFilter{
    profileName?: string,
    year?: number,
    container?: string,
    clientId?: number,
    status?: number,
    importOrder?: string,
    programId?: number,
    transportType?: number,
    speciesId?: string,
    varietyId?: string,
    naveId?: string,
    departurePortId?: string,
    destinationPortId?: string,
}

export class FilterLoadsUtils {

    static saveFilterConfig(filter: MyLoadsFilter)
    {
        sessionStorage.setItem("_loads_config", JSON.stringify(filter));
    }

    static getFilterConfig(): MyLoadsFilter | undefined
    {
        let data = sessionStorage.getItem("_loads_config");

        if(data)
        {
            return JSON.parse(data)
        }

        return undefined;
    }

    static removeFilterConfig()
    {
        sessionStorage.removeItem("_loads_config");
    }

    static saveFilterProgramConfig(programFilter: MyLoadsFilterProgram)
    {
        sessionStorage.setItem("_loads_program_config", JSON.stringify(programFilter));
    }

    static getFilterProgramConfig(): MyLoadsFilter | undefined
    {
        let data = sessionStorage.getItem("_loads_program_config");

        if(data)
        {
            return JSON.parse(data)
        }

        return undefined;
    }

    static removeFilterProgramConfig()
    {
        sessionStorage.removeItem("_loads_program_config");
    }

}
